import db from '../../../db/db'

export const DEXIE_STORE_NAMES = ['visits', 'invitations', 'employees', 'black_lists', 'comes_from', 'sync_meta', 'quarantined_visits', 'pending_visit_photos']

export async function getStoreCounts() {
  const entries = await Promise.all(
    DEXIE_STORE_NAMES.map(async name => [name, await db[name].count()])
  )
  return Object.fromEntries(entries)
}

export async function getSyncMeta() {
  return db.sync_meta.toArray()
}

export async function getAllVisits() {
  return db.visits.toArray()
}

export async function getVisitsByStatus(status) {
  return db.visits.where('syncStatus').equals(status).toArray()
}

export async function getVisitStatusCounts() {
  const visits = await getAllVisits()
  return visits.reduce((acc, v) => {
    const key = v.syncStatus || 'unknown'
    acc[key] = (acc[key] || 0) + 1
    return acc
  }, { pending: 0, synced: 0, failed: 0 })
}

export async function getComesFromRows() {
  return db.comes_from.toArray()
}

export async function getBlackListRows() {
  return db.black_lists.toArray()
}

export async function getEmployeeRows() {
  return db.employees.toArray()
}
